import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "messageSend/";

// 收件箱 - 列表
export const myMsgPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "page", {
           data: _params,
           method: "GET",
         });
       };

// 收件箱 - 获取未读消息数
export const myMsgUnReadNum = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "unReadNum", {
           data: _params,
           method: "GET",
         });
       };

// 收件箱 - 详情
export const myMsgView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "view", {
    data: _params,
    method: "GET",
  });
};
// 收件箱 - 标记已读-全部
export const myMsgReadAll = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "readAll", {
    data: _params,
    method: "POST",
  });
};


// WEBPACK FOOTER //
// ./src/fetch/api/myMsg.js